import { render, staticRenderFns } from "./BorcluDetayView.vue?vue&type=template&id=25bea42c&scoped=true"
import script from "./BorcluDetayView.vue?vue&type=script&lang=ts"
export * from "./BorcluDetayView.vue?vue&type=script&lang=ts"
import style0 from "./BorcluDetayView.vue?vue&type=style&index=0&id=25bea42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bea42c",
  null
  
)

export default component.exports